/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostRecruitmentCreate201,
  PostRecruitmentCreate400,
  PostRecruitmentCreateMutationRequest,
  PostRecruitmentCreateMutationResponse,
} from '../entities/PostRecruitmentCreate'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1CreateRecruitmentInputSchema } from './v1/createRecruitmentInputSchema'
import { v1CreateRecruitmentResponseSchema } from './v1/createRecruitmentResponseSchema'
import { z } from 'zod'

/**
 * @description Created
 */
export const postRecruitmentCreate201Schema = z.lazy(() => v1CreateRecruitmentResponseSchema) as unknown as ToZod<PostRecruitmentCreate201>

/**
 * @description Bad Request
 */
export const postRecruitmentCreate400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostRecruitmentCreate400>

/**
 * @description Данные вербовки
 */
export const postRecruitmentCreateMutationRequestSchema = z.lazy(() => v1CreateRecruitmentInputSchema) as unknown as ToZod<PostRecruitmentCreateMutationRequest>

export const postRecruitmentCreateMutationResponseSchema = z.lazy(
  () => postRecruitmentCreate201Schema,
) as unknown as ToZod<PostRecruitmentCreateMutationResponse>